import {Button} from "@/components/ui/Button";
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {Dialog} from "@/components/ui/dialog";
import {DialogContent} from "@/components/ui/dialog";
import {Icon} from "@/components/ui/icon";
import {cn} from "@/lib/utils";
import {Loader2, TextCursorInput} from "lucide-react";

export const SwitchModeModal = ({
  onSwitchMode,
  showModal,
  setShowModal,
  loading,
}: {
  onSwitchMode: () => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  loading: boolean;
}) => {
  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent
        className={cn(
          "w-110 min-w-110 block overflow-hidden",
          loading && "[&>button[data-dialog-close]]:hidden",
        )}
        onInteractOutside={e => loading && e.preventDefault()}
        onEscapeKeyDown={e => loading && e.preventDefault()}
      >
        <DialogHeader className="sr-only">
          <DialogTitle>Switch to Prompt Mode</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          Switching modes will save the entered instructions but will apply the
          instructions written for Prompt Mode.
        </DialogDescription>
        <div className="bg-white p-6 rounded-lg w-110 flex flex-col items-center gap-5">
          <Icon
            className="bg-opacity-10 border-opacity-30 rounded-lg bg-primary border-primary"
            size="lg"
          >
            {loading ? (
              <Loader2 className="animate-spin text-primary-accent" size={28} />
            ) : (
              <TextCursorInput className="text-primary-accent" size={28} />
            )}
          </Icon>
          <div className="flex flex-col items-center gap-2 text-center">
            <h2 className="text-lg font-bold">
              {loading ? "Saving..." : "Switch to Prompt Mode"}
            </h2>
            <p className="text-sm text-label">
              {loading
                ? "You'll be redirected to the Prompt Mode after saving"
                : "Switching modes will save the entered instructions but will apply the instructions written for Prompt Mode."}
            </p>
          </div>
          <div className="flex justify-between w-full gap-3">
            <Button
              onClick={() => setShowModal(false)}
              variant="outline"
              className="w-1/2"
              disabled={loading}
            >
              No, Stay
            </Button>
            <Button
              onClick={() => onSwitchMode && onSwitchMode()}
              className="w-1/2"
              disabled={loading}
            >
              Yes, Switch Mode
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
